<template>
  <!-- Bank Transfer Modal Structure -->
  <div id="bank_transfer" class="modal services">
    <div v-if="!verified">
      <div class="modal-header">
        <!-- <a class="modal-close waves-effect btn-small waves-green right">x</a> -->
        <img src="ui/img/logo.png" width="18%" class="responsive-img" />
      </div>
      <div class="modal-content">
        <h5>Pay Via Bank Transfer</h5>
        <p class="text-center">
          You can transfer the value of <strong>&#8358; {{ amount }}</strong> to
          the bank account below.
        </p>
        <div class="alert alert-info" role="alert" v-if="details.type">
          <strong>NB:</strong> This account number is generated for this
          transaction alone. It cannot be reused for another transaction and
          expires after 11:59pm today.
        </div>
        <table class="highlight centered responsive-table">
          <tbody>
            <tr>
              <th>BANK NAME</th>
              <th>{{ details.bank }}</th>
            </tr>
            <tr>
              <th>ACCOUNT NAME</th>
              <th>{{ details.account_name }}</th>
            </tr>
            <tr>
              <th>ACCOUNT NUMBER</th>
              <th>{{ details.account_number }}</th>
            </tr>
            <tr>
              <th>AMOUNT TO PAY</th>
              <th>&#8358; {{ amount }}</th>
            </tr>
          </tbody>
        </table>
        <div v-if="details.type">
          <p class="text-justify">
            <strong>IMPORTANT:</strong> Include your reference number
            <strong>{{ transactionID }}</strong> in the remark section when making
            the transfer from your online banking profile.<br /><br />
            Upon successful transfer, wait for a minute and click on the "Confirm
            payment" button below to check the status of your transaction. Thank
            you for choosing iRecharge.
          </p>
          <div v-if="bankVending">
            <div class="alert bankAlert alert-warning">{{ errorMessage }}</div>
          </div>
          <div v-if="loading">
            <img src="ui/img/loading.svg" alt="Time Loader" />
            <p><i>Loading...</i></p>
          </div>
          <div class="modal-footer">
            <a
              class="confirm-payment waves-effect waves-green btn-flat"
              style="margin-right: 10px;"
              @click.prevent="confirmPayment"
              >Confirm Payment</a
            >
            <a
              class="modal-close waves-effect waves-green btn-flat"
              @click="removeAlert"
              >Change payment option</a
            >
          </div>
        </div>
        <div v-else>
          <p class="text-justify">	
            <strong>IMPORTANT:</strong> Include your reference number <strong>{{transactionID}}</strong> in the remark section when making the transfer from your online banking profile.<br><br>	
            Upon successful transfer, send an SMS with your reference number: <strong>{{transactionID}}</strong>, amount paid and Account holder's name to <strong>09030009930</strong> to confirm payment.	
          </p>
          <div class="modal-footer">	
            <a class="modal-close waves-effect waves-green btn-flat" style="margin-right: 10px">Change payment option</a>	
            <a class="modal-close waves-effect waves-green btn-flat">Close</a>	
          </div>
        </div>
      </div>
    </div>
    <div class="modal-content" style="margin: 24px" v-else>
      <img src="ui/img/success.png" width="12%" class="responsive-img" />
      <h6>Your order has been completed sucessfully.</h6>
      <h6><strong>Transaction Details</strong></h6>
      <p><strong>Order Info:</strong> {{ reply.title }}</p>
      <p><strong>Transaction Ref:</strong> {{ transactionID }}</p>
      <p><strong>Payment Ref:</strong> {{ reply.payment_ref }}</p>
      <div v-if="service == 'electricity'">
        <p>
          <strong>
            <span class="token">Token: {{ reply.token }}</span>
          </strong>
          <br />
          <button
            type="button"
            @click="doCopy"
            class="copyBtn btn-small"
            style="padding: 1px 7px; font-size: 11px;"
          >
            Click to copy
          </button>
        </p>
        <p>
          <span class="token">Units: {{ reply.units }}</span>
        </p>
      </div>
      <a
        class="modal-close waves-effect waves-green btn-small"
        style="margin-right: 10px"
        @click="resetArea"
        >Close</a
      >
    </div>
  </div>
  <!-- Bank Transfer Modal Structure -->
</template>
<script>
/* eslint-disable */
export default {
  props: {
    amount: { type: [String, Number], required: true }, 
    service: { type: String, required: true }, 
    details: { type: Object, required: true },
    transactionID: { type: String, required: true }
  },
  data() {
    return {
      verified: false,
      alertError: false,
      verify: {
        action: 'confirm_ussd',
      },
      reply: {},
      bankVending: false,
      loading: false,
      errorMessage: ''
    }
  },
  methods: {
    confirmPayment() {
      // $('.alert.bankAlert').hide()
      this.loading =  true
      this.verify.transaction_id = this.transactionID
      this.verify.service = this.service
      this.verify.passcode = this.hash(this.verify.transaction_id.toString())
      this.axios.post('https://irecharge.com.ng/api/misc/confirm_ussd.php', this.verify)
      .then(response => {
        if(response.data.status == "0") {
          this.reply.payment_ref = response.data.payment_ref
          this.reply.title = response.data.title
          if(this.service == 'electricity') {
            this.reply.token = this.spaceToken(response.data.token, 4).join('-')
            this.reply.units = response.data.units
          }
          $('.toast').hide()
          this.verified = true
          this.loading = false
        } else {
          this.errorMessage = response.data.message
          this.loading = false
          this.bankVending = true
        }
      })
      .catch(error => {
        $('.toast').hide()
        M.toast({ html: 'Could not send request, check network.', classes: 'error' })
      })
    },
    spaceToken(str, n) {
      var ret = [];
      var i;
      var len;
      for(i = 0, len = str.length; i < len; i += n) {
        ret.push(str.substr(i, n))
      }
      return ret
    },
    removeAlert() {
      $('.alert.alert-warning').hide()
      this.bankVending = false
    },
    doCopy: function () {
      let container = this.$refs.container
      this.$copyText(this.reply.token, container)
      $('.copyBtn').text("Copied")
      setTimeout(() => {
        $('.copyBtn').text("Click to copy")
      }, 3000);
    },
    resetArea() {
      this.bankVending = false
      this.verified = false
      this.loading = false
      this.$emit('ussd-complete')
    },
    hash(ref) {
      let passcode = '123NDSx'
      let encrypted = CryptoJS.HmacSHA512(ref, passcode);
      return encrypted.toString()
    }
  }
}
</script>
<style scoped>
.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.alert.alert-warning {
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
}
.alert.alert-info {
  color: #0c5460;
  background-color: #d1ecf1;
  border-color: #bee5eb;
}
.modal .modal-content {
  padding: 0px 24px;
}
.confirm-payment {
  background-color: #1dab61;
  color: #fff;
  font-weight: bold;
  letter-spacing: 1px;
}
.confirm-payment:hover {
  background-color: #3e9266;
}
span.token {
  font-size: 22px;
}
.alert {
  position: relative;
  padding: .75rem 1.25rem;
  margin-top: 1rem;
  border: 1px solid transparent;
  border-radius: .25rem;
}
.alert-warning {
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
}
</style>